import React from 'react';

import type { SVGProps } from '@atlaskit/icon/svg';
import SVG from '@atlaskit/icon/svg';

export const DraftIcon = (props: SVGProps) => (
	<SVG {...props}>
		<rect width="24" height="24" fill="none" fillOpacity="0.01" />
		<path
			xmlns="http://www.w3.org/2000/svg"
			d="M12.5858 4C13.1162 4 13.6249 4.21074 14 4.58582L17.4142 8C17.7893 8.37507 18 8.88375 18 9.41418V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V6C6 4.89543 6.89543 4 8 4H12.5858ZM11 6H8V18H16V11H13C11.9456 11 11.0818 10.1842 11.0055 9.14929L11 9V6ZM15.586 9L13 6.41504V9H15.586Z"
			fill="currentColor"
		/>
	</SVG>
);
